import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { isClientTaxExempt } from '~/models/ClientModel';
const rateToPreset = (rate)=>_object_spread({
        id: rate.id,
        name: rate.name,
        status: 'active',
        components: rate.components.map((component)=>({
                id: component.id,
                name: component.name,
                rate: component.rate
            }))
    }, rate.mappingStatus != null ? {
        mappingStatus: rate.mappingStatus
    } : {});
export const salesTaxConfigFromDTO = (dto)=>({
        enabled: dto.enabled,
        displayMode: dto.displayMode,
        label: dto.label,
        presets: dto.rates.map(rateToPreset)
    });
export const rateCreateBody = (preset)=>({
        name: preset.name,
        components: preset.components.map((component)=>({
                name: component.name,
                rate: component.rate
            }))
    });
export const rateEditBody = (previous, next)=>{
    const serverComponentIds = new Set(previous.components.map((component)=>component.id));
    return {
        name: next.name,
        components: next.components.map((component)=>serverComponentIds.has(component.id) ? {
                id: component.id,
                name: component.name,
                rate: component.rate
            } : {
                name: component.name,
                rate: component.rate
            })
    };
};
export const combinedRate = (preset)=>preset.components.reduce((sum, c)=>sum + (parseFloat(c.rate) || 0), 0);
export const formatPercent = (rate)=>{
    const n = typeof rate === 'string' ? parseFloat(rate) : rate;
    if (Number.isNaN(n)) return '0.00%';
    return "".concat(n.toFixed(2), "%");
};
export const replacePreset = (config, next)=>_object_spread_props(_object_spread({}, config), {
        presets: config.presets.map((p)=>p.id === next.id ? next : p)
    });
export const addPreset = (config, next)=>_object_spread_props(_object_spread({}, config), {
        presets: [
            ...config.presets,
            next
        ]
    });
export const isDuplicateName = (presets, name, excludingId)=>presets.some((p)=>p.id !== excludingId && p.name.trim().toLowerCase() === name.trim().toLowerCase());
export const isPresetMapped = (preset)=>{
    var _ref;
    var _preset_mappingStatus;
    return (_ref = preset === null || preset === void 0 ? void 0 : (_preset_mappingStatus = preset.mappingStatus) === null || _preset_mappingStatus === void 0 ? void 0 : _preset_mappingStatus.some((m)=>m.status !== 'unmapped')) !== null && _ref !== void 0 ? _ref : false;
};
export const presetMappingStatusFor = (preset, integrationName)=>{
    var _ref;
    var _preset_mappingStatus_find, _preset_mappingStatus;
    return (_ref = (_preset_mappingStatus = preset.mappingStatus) === null || _preset_mappingStatus === void 0 ? void 0 : (_preset_mappingStatus_find = _preset_mappingStatus.find((m)=>m.integrationName === integrationName)) === null || _preset_mappingStatus_find === void 0 ? void 0 : _preset_mappingStatus_find.status) !== null && _ref !== void 0 ? _ref : 'unmapped';
};
export const needsTaxRate = (param)=>{
    let { presetId, lines, clientTaxSettings, config } = param;
    if ((config === null || config === void 0 ? void 0 : config.enabled) !== true) return false;
    if (clientTaxSettings != null && isClientTaxExempt(clientTaxSettings)) return false;
    if (!lines.some((line)=>line.taxable)) return false;
    return presetId == null;
};
export const getComponentSuggestions = ()=>[];
export function isServiceTaxable(service) {
    var _service_taxable;
    return (_service_taxable = service.taxable) !== null && _service_taxable !== void 0 ? _service_taxable : false;
}
